import React, { useEffect } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { windowScrollTo } from '../../../utils';
import { Notifications } from '../components';
import { RegistrationFailureMessageProps } from './types';
import {
  DUPLICATE_EMAIL,
  DUPLICATE_EMAIL_USERNAME,
  FORBIDDEN_REQUEST,
  INTERNAL_SERVER_ERROR,
} from './constants';

import messages from './messages';

const RegistrationNotification = (
  { code, count }: RegistrationFailureMessageProps,
): React.ReactElement | null => {
  const intl = useIntl();

  useEffect(() => {
    windowScrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }, [code, count]);

  if (!code) {
    return null;
  }

  let errorMessage: React.ReactNode = '';
  switch (code) {
    case INTERNAL_SERVER_ERROR:
      errorMessage = intl.formatMessage(messages.requestServerError);
      break;
    case FORBIDDEN_REQUEST:
      errorMessage = intl.formatMessage(messages.requestForbiddenError);
      break;
    case DUPLICATE_EMAIL:
      errorMessage = intl.formatMessage(messages.requestDuplicateEmailError);
      break;
    case DUPLICATE_EMAIL_USERNAME:
      errorMessage = intl.formatMessage(messages.requestDuplicateUsernameError);
      break;
    default:
      errorMessage = intl.formatMessage(messages.requestUnknownError);
      break;
  }

  return (
    <Notifications
      title={intl.formatMessage(messages.requestFailureHeader)}
      message={errorMessage}
      count={count}
    />
  );
};

export default RegistrationNotification;
